<div class="developer-catalog-page">
  <div class="page-header">
    <div class="page-header__title">
      <h2>{{ 'Code catalog' | translate }}</h2>
      <p *ngIf="catalog() as data">
        {{ 'mediator' | translate }}: {{ mediatorCount() }}
        ({{ kindCounts().Command }} cmd · {{ kindCounts().Query }} qry · {{ kindCounts().Request }} req ·
        {{ kindCounts().CliCommand }} devops)
        · {{ cqrsIssueCount() }} cqrs · {{ 'devops placement' | translate }}: {{ devopsPlacementIssueCount() }} ·
        {{ 'fat jobs' | translate }}: {{ jobLogicIssueCount() }} ·
        {{ 'controllers' | translate }}: {{ controllerCount() }} ({{ 'fat' | translate }}: {{ controllerLogicIssueCount() }}) ·
        {{ 'UnitOfWork naming' | translate }}: {{ unitOfWorkNamingIssueCount() }} ·
        {{ 'jobs' | translate }}: {{ data.jobs?.length || 0 }} ·
        {{ 'not a process' | translate }}: {{ leftoverJobCount() }} ·
        {{ 'authors' | translate }}: {{ authorProfiles().length }} · {{ 'services' | translate }}: {{ serviceProfiles().length }} ·
        StartJobs={{ data.startJobs }} · {{ data.generatedBy }}
      </p>
    </div>
    <div class="page-header__search">
      <app-orchestration-catalog-search [(query)]="headerQuery"></app-orchestration-catalog-search>
    </div>
    <div class="header-actions">
      <app-secondary-button class="header-actions__refresh" title="Refresh" icon="pi pi-refresh" (action)="reload()"></app-secondary-button>
    </div>
  </div>

  <app-loading *ngIf="loading()"></app-loading>

  <div *ngIf="error() as message" class="error">{{ message | translate }}</div>

  <p-tabs
    *ngIf="!loading() && catalog()"
    [value]="activeTab()"
    (valueChange)="onTabChange($event)"
    [lazy]="true"
    class="catalog-tabs"
  >
    <p-tablist>
      <p-tab value="Mediator">
        {{ 'Mediator' | translate }}
        <span class="tab-count">{{ mediatorCount() }}</span>
      </p-tab>
      <p-tab value="Jobs">
        {{ 'Jobs' | translate }}
        <span class="tab-count">{{ catalog()?.jobs?.length || 0 }}</span>
      </p-tab>
      <p-tab value="Controllers">
        {{ 'Controllers' | translate }}
        <span class="tab-count">{{ controllerCount() }}</span>
      </p-tab>
      <p-tab value="Authors">
        {{ 'Authors' | translate }}
        <span class="tab-count">{{ authorProfiles().length }}</span>
      </p-tab>
      <p-tab value="Services">
        {{ 'Services' | translate }}
        <span class="tab-count">{{ serviceProfiles().length }}</span>
      </p-tab>
    </p-tablist>
    <p-tabpanels class="catalog-tabpanels">
      <p-tabpanel value="Mediator" class="catalog-tabpanel">
        <ng-container *ngTemplateOutlet="mediatorPanel"></ng-container>
      </p-tabpanel>

      <p-tabpanel value="Jobs" class="catalog-tabpanel">
        <div class="toolbar">
          <input
            pInputText
            type="text"
            [placeholder]="'Filter jobs, description, commands...' | translate"
            [ngModel]="jobFilter()"
            (ngModelChange)="jobFilter.set($event)"
          />
        </div>

        <div class="workspace" [class.with-details]="!!selectedJob()">
          <aside class="group-list">
            <button
              type="button"
              class="group-item"
              *ngFor="let group of jobGroups()"
              [class.active]="activeJobGroup() === group.group"
              [class.archive]="isArchiveGroup(group.group)"
              (click)="selectJobGroup(group.group)"
            >
              <span class="group-name">{{ catalogGroupLabel(group.group) }}</span>
              <span class="group-count">{{ group.items.length }}</span>
            </button>
            <div *ngIf="!jobGroups().length" class="empty muted">{{ 'No groups match the filter' | translate }}</div>
          </aside>

          <section class="items-panel">
            <div class="panel-title" *ngIf="activeJobGroup() as groupName">
              {{ catalogGroupLabel(groupName) }}
              <span class="muted">· {{ selectedJobItems().length }}</span>
            </div>
            <div class="table-scroll">
              <p-table
                [value]="selectedJobItems()"
                styleClass="p-datatable-sm p-datatable-striped"
                [scrollable]="true"
                scrollHeight="flex"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Job' | translate }}</th>
                    <th>{{ 'Description' | translate }}</th>
                    <th>{{ 'Runtime' | translate }}</th>
                    <th>{{ 'Runs' | translate }}</th>
                    <th>{{ 'Refs' | translate }}</th>
                    <th>{{ 'Commands' | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-job>
                  <tr
                    (click)="selectJob(job)"
                    class="clickable-row"
                    [class.selected-row]="selectedJob()?.name === job.name"
                  >
                    <td>
                      <a [routerLink]="jobLink(job.name || '')" (click)="$event.stopPropagation()">
                        {{ job.name }}
                      </a>
                      <app-catalog-authors [authors]="job.authors"></app-catalog-authors>
                      <p-tag
                        *ngIf="isLegacyCronJob(job)"
                        class="kind-tag"
                        severity="warn"
                        [value]="'not a process' | translate"
                        [pTooltip]="'This job still owns business work and has not moved to a process assignment.' | translate"
                        tooltipPosition="top"
                      ></p-tag>
                      <p-tag *ngIf="job.discoveredAtRuntime" severity="warn" value="runtime"></p-tag>
                      <p-tag
                        *ngIf="isCatalogItemObsolete(job)"
                        class="kind-tag"
                        severity="secondary"
                        value="obsolete"
                        pTooltip="Retired: marked [Obsolete]"
                        tooltipPosition="top"
                      ></p-tag>
                      <p-tag
                        *ngIf="!isOrchestrationCompliant(job)"
                        class="kind-tag"
                        severity="danger"
                        [value]="'logic' | translate"
                        [pTooltip]="orchestrationIssuesTooltip(job) | translate"
                        tooltipPosition="top"
                      ></p-tag>
                      <div
                        class="external-services inline"
                        *ngIf="job.externalServices?.length"
                        [pTooltip]="externalServicesTooltip(job.externalServices)"
                        tooltipPosition="top"
                      >
                        <p-tag
                          *ngFor="let service of (job.externalServices || []).slice(0, 2)"
                          class="service-tag"
                          [severity]="isExternalServiceNamingCompliant(service) ? 'secondary' : 'danger'"
                          [value]="service.name || undefined"
                        ></p-tag>
                        <span class="muted" *ngIf="(job.externalServices || []).length > 2">…</span>
                      </div>
                      <div class="muted">{{ job.featureFlag || '—' }}</div>
                    </td>
                    <td class="description-cell">{{ (job | serverTranslate:'descriptions') || job.description || '—' }}</td>                    <td>
                      <p-tag
                        [severity]="runtimeSeverity(job.runtimeStatus)"
                        [value]="job.runtimeStatus || undefined"
                      ></p-tag>
                    </td>
                    <td>
                      <a
                        class="runs-cell"
                        [routerLink]="['/admin/process-management/monitoring']"
                        [queryParams]="{ kind: 'JobExecution', search: job.name }"
                        (click)="$event.stopPropagation()"
                        [pTooltip]="formatExecutionTooltip(job.executionCount, job.lastExecutedAt)"
                        tooltipPosition="top"
                      >
                        {{ formatExecutionSummary(job.executionCount, job.lastExecutedAt) }}
                      </a>
                    </td>
                    <td>
                      <span
                        class="ref-count"
                        [pTooltip]="jobReferencesTooltip(job)"
                        tooltipPosition="top"
                      >
                        {{ jobReferenceCount(job) }}
                      </span>
                    </td>
                    <td>
                      <ng-container *ngIf="(job.referencedCommands || job.usedCommands)?.length; else noCommands">
                        <a
                          *ngFor="let command of (job.referencedCommands || job.usedCommands || []).slice(0, 3); let last = last"
                          [routerLink]="commandLink(command)"
                          (click)="$event.stopPropagation()"
                          class="ref-link"
                          [pTooltip]="(job.referencedCommands || job.usedCommands || []).join(', ')"
                        >
                          {{ command }}<span *ngIf="!last">, </span>
                        </a>
                        <span *ngIf="(job.referencedCommands || job.usedCommands || []).length > 3">…</span>
                      </ng-container>
                      <ng-template #noCommands>—</ng-template>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6" class="muted">{{ 'Select a group or adjust the filter' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </section>

          <aside class="details" *ngIf="selectedJob() as job">
            <h2>
              <a [routerLink]="jobLink(job.name || '')">{{ job.name }}</a>
              <app-catalog-authors [authors]="job.authors"></app-catalog-authors>
              <p-tag
                *ngIf="isLegacyCronJob(job)"
                class="kind-tag"
                severity="warn"
                [value]="'not a process' | translate"
                [pTooltip]="'This job still owns business work and has not moved to a process assignment.' | translate"
                tooltipPosition="top"
              ></p-tag>
              <p-tag
                *ngIf="isCatalogItemObsolete(job)"
                class="kind-tag"
                severity="secondary"
                value="obsolete"
              ></p-tag>
            </h2>
            <p class="muted">{{ catalogGroupLabel(job.group) }} · {{ job.sourcePath }}</p>
            <h3>{{ 'Description' | translate }}</h3>
            <p>{{ (job | serverTranslate:'descriptions') || job.description || ('No XML summary found on the job type.' | translate) }}</p>
            <h3>{{ 'Executions' | translate }}</h3>
            <p>
              <a
                [routerLink]="['/admin/process-management/monitoring']"
                [queryParams]="{ kind: 'JobExecution', search: job.name }"
                [pTooltip]="formatExecutionTooltip(job.executionCount, job.lastExecutedAt)"
                tooltipPosition="top"
              >
                {{ formatExecutionSummary(job.executionCount, job.lastExecutedAt) }}
              </a>
              <span class="muted"> · {{ 'from operation monitoring' | translate }}</span>
            </p>
            <h3>{{ 'Status' | translate }}</h3>
            <p>
              <p-tag
                [severity]="runtimeSeverity(job.runtimeStatus)"
                [value]="job.runtimeStatus || undefined"
              ></p-tag>
              · {{ job.registrationStatus }}
              · {{ 'Scheduled' | translate }}: {{ job.isScheduled ? ('yes' | translate) : ('no' | translate) }}
            </p>
            <h3>{{ 'Feature flag' | translate }}</h3>
            <p>
              {{ job.featureFlag || '—' }}
              <span *ngIf="job.featureFlagEnabled === true"> {{ '(on)' | translate }}</span>
              <span *ngIf="job.featureFlagEnabled === false"> {{ '(off)' | translate }}</span>
            </p>
            <h3>{{ 'External services' | translate }}</h3>
            <div class="external-services" *ngIf="job.externalServices?.length; else noJobServices">
              <p-tag
                *ngFor="let service of job.externalServices"
                class="service-tag"
                [severity]="isExternalServiceNamingCompliant(service) ? 'secondary' : 'danger'"
                [value]="service.name || undefined"
                [pTooltip]="
                  service.project
                    + (service.entryPoint ? ' · ' + service.entryPoint : '')
                    + (isExternalServiceNamingCompliant(service)
                      ? ''
                      : '\n' + externalServiceNamingIssuesTooltip(service))
                "
                tooltipPosition="top"
              ></p-tag>
            </div>
            <ng-template #noJobServices>
              <p class="muted">{{ 'No external services detected' | translate }}</p>
            </ng-template>
            <ng-container *ngIf="!isOrchestrationCompliant(job)">
              <h3>{{ 'Orchestration issues' | translate }}</h3>
              <ul>
                <li *ngFor="let issue of job.orchestrationIssues || []">{{ issue }}</li>
              </ul>
            </ng-container>
            <h3>{{ 'Commands used' | translate }} ({{ jobReferenceCount(job) }})</h3>
            <ul>
              <li *ngFor="let command of job.referencedCommands || job.usedCommands || []">
                <app-copyable-identifier [value]="command" [link]="commandLink(command)"></app-copyable-identifier>
              </li>
              <li *ngIf="!(job.referencedCommands?.length || job.usedCommands?.length)" class="muted">
                {{ 'No MediatR commands referenced' | translate }}
              </li>
            </ul>
          </aside>
        </div>
      </p-tabpanel>

      <p-tabpanel value="Controllers" class="catalog-tabpanel">
        <div class="toolbar">
          <input
            pInputText
            type="text"
            [placeholder]="'Filter controllers, actions, kind, logic, cqrs...' | translate"
            [ngModel]="controllerFilter()"
            (ngModelChange)="controllerFilter.set($event)"
          />
        </div>

        <div class="workspace" [class.with-details]="!!selectedController()">
          <aside class="group-list">
            <button
              type="button"
              class="group-item"
              *ngFor="let group of controllerGroups()"
              [class.active]="activeControllerGroup() === group.group"
              (click)="selectControllerGroup(group.group)"
            >
              <span class="group-name">{{ group.group }}</span>
              <span class="group-count">{{ group.items.length }}</span>
            </button>
            <div *ngIf="!controllerGroups().length" class="empty muted">{{ 'No groups match the filter' | translate }}</div>
          </aside>

          <section class="items-panel">
            <div class="panel-title" *ngIf="activeControllerGroup() as groupName">
              {{ groupName }}
              <span class="muted">· {{ selectedControllerItems().length }}</span>
            </div>
            <div class="table-scroll">
              <p-table
                [value]="selectedControllerItems()"
                styleClass="p-datatable-sm p-datatable-striped"
                [scrollable]="true"
                scrollHeight="flex"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Controller' | translate }}</th>
                    <th>{{ 'Route' | translate }}</th>
                    <th
                      [pTooltip]="'HTTP endpoints (action methods) on this controller' | translate"
                      tooltipPosition="top"
                    >
                      {{ 'Endpoints' | translate }}
                    </th>
                    <th
                      [pTooltip]="'Actions with business logic in the controller, or HTTP verb/name mismatch' | translate"
                      tooltipPosition="top"
                    >
                      {{ 'Problems' | translate }}
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-controller>
                  <tr
                    (click)="selectController(controller)"
                    class="clickable-row"
                    [class.selected-row]="selectedController()?.name === controller.name"
                  >
                    <td>
                      <code>{{ controller.name }}</code>
                      <app-catalog-authors [authors]="controller.authors"></app-catalog-authors>
                    </td>
                    <td class="description-cell">{{ controller.route || '—' }}</td>
                    <td class="stat-cell">
                      <span class="stat-label">{{ 'Endpoints' | translate }}: {{ controller.actions?.length || 0 }}</span>
                    </td>
                    <td class="stat-cell">
                      <ng-container
                        *ngIf="(controller.orchestrationIssueCount || 0) || (controller.cqrsIssueCount || 0); else controllerOk"
                      >
                        <p-tag
                          *ngIf="controller.orchestrationIssueCount"
                          class="kind-tag"
                          severity="danger"
                          [value]="(controller.orchestrationIssueCount || 0) + ' ' + ('with logic' | translate)"
                          [pTooltip]="orchestrationIssuesTooltip(controller) | translate"
                          tooltipPosition="top"
                        ></p-tag>
                        <p-tag
                          *ngIf="controller.cqrsIssueCount"
                          class="kind-tag"
                          severity="warn"
                          [value]="(controller.cqrsIssueCount || 0) + ' ' + ('naming' | translate)"
                          [pTooltip]="'HTTP verb does not match the action/command naming (CQRS)' | translate"
                          tooltipPosition="top"
                        ></p-tag>
                      </ng-container>
                      <ng-template #controllerOk>
                        <span class="muted">{{ 'no issues' | translate }}</span>
                      </ng-template>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4" class="muted">{{ 'Select a group or adjust the filter' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </section>

          <aside class="details" *ngIf="selectedController() as controller">
            <h2>{{ controller.name }}</h2>
            <p class="muted">{{ controller.group }} · {{ controller.route || '—' }} · {{ controller.sourcePath }}</p>
            <h3>{{ 'Description' | translate }}</h3>
            <p>{{ (controller | serverTranslate:'descriptions') || controller.description || ('No XML summary found on the controller type.' | translate) }}</p>
            <ng-container *ngIf="!isOrchestrationCompliant(controller)">
              <h3>{{ 'Orchestration issues' | translate }}</h3>
              <ul>
                <li *ngFor="let issue of controller.orchestrationIssues || []">{{ issue }}</li>
              </ul>
            </ng-container>
            <h3>{{ 'HTTP endpoints' | translate }} ({{ controller.actions?.length || 0 }})</h3>
            <ul class="type-list">
              <li *ngFor="let action of controller.actions || []">
                <div>
                  <p-tag
                    *ngFor="let method of action.httpMethods || []"
                    class="kind-tag"
                    severity="secondary"
                    [value]="method"
                  ></p-tag>
                  <p-tag
                    class="kind-tag"
                    [severity]="catalogKindSeverity(action.kind)"
                    [value]="action.kind || undefined"
                  ></p-tag>
                  <p-tag
                    *ngIf="!isOrchestrationCompliant(action)"
                    class="kind-tag"
                    severity="danger"
                    [value]="'with logic' | translate"
                    [pTooltip]="orchestrationIssuesTooltip(action) | translate"
                    tooltipPosition="top"
                  ></p-tag>
                  <p-tag
                    *ngIf="action.cqrsCompliant === false"
                    class="kind-tag"
                    severity="warn"
                    [value]="'naming' | translate"
                    [pTooltip]="actionCqrsIssuesTooltip(action) | translate"
                    tooltipPosition="top"
                  ></p-tag>
                  <code>{{ action.name }}</code>
                  <span class="muted" *ngIf="action.route"> · {{ action.route }}</span>
                </div>
                <div class="muted" *ngIf="action.usedCommands?.length">
                  {{ 'commands:' | translate }}
                  <a
                    *ngFor="let command of action.usedCommands; let last = last"
                    [routerLink]="commandLink(command)"
                    class="ref-link"
                  >
                    {{ command }}<span *ngIf="!last">, </span>
                  </a>
                </div>
              </li>
              <li *ngIf="!(controller.actions?.length)" class="muted">{{ 'No HTTP actions indexed' | translate }}</li>
            </ul>
          </aside>
        </div>
      </p-tabpanel>

      <p-tabpanel value="Authors" class="catalog-tabpanel">
        <div class="toolbar">
          <input
            pInputText
            type="text"
            [placeholder]="'Filter authors, initials, files...' | translate"
            [ngModel]="authorFilter()"
            (ngModelChange)="authorFilter.set($event)"
          />
        </div>

        <div class="workspace">
          <aside class="group-list">
            <button
              type="button"
              class="group-item author-item"
              *ngFor="let profile of filteredAuthorProfiles()"
              [class.active]="activeAuthor()?.name === profile.name"
              (click)="selectAuthor(profile)"
            >
              <span class="author-item-main">
                <span class="author-chip" [ngStyle]="authorChipStyle(profile)">{{ profile.initials }}</span>
                <span class="group-name" [title]="profile.name">{{ profile.name }}</span>
              </span>
              <span class="group-count">{{ profile.itemCount }}</span>
            </button>
            <div *ngIf="!filteredAuthorProfiles().length" class="empty muted">{{ 'No authors match the filter' | translate }}</div>
          </aside>

          <section class="items-panel">
            <div class="panel-title" *ngIf="activeAuthor() as author">
              <span class="author-chip" [ngStyle]="authorChipStyle(author)">{{ author.initials }}</span>
              {{ author.name }}
              <span class="muted">
                · {{ 'mediator' | translate }}: {{ author.commandCount }} · {{ 'jobs' | translate }}: {{ author.jobCount }} ·
                {{ 'controllers' | translate }}: {{ author.controllerCount }} · {{ 'avg' | translate }} {{ author.avgPercent }}%
              </span>
            </div>
            <div class="table-scroll">
              @if (activeAuthor()) {
                @for (group of authorParticipationGroups(); track group.group) {
                  <div class="participation-group">
                    <div class="participation-group__title">
                      <span>{{ catalogGroupLabel(group.group) }}</span>
                      <span class="group-count">{{ group.items.length }}</span>
                    </div>
                    <p-table
                      [value]="group.items"
                      styleClass="p-datatable-sm p-datatable-striped"
                      [scrollable]="true"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th>{{ 'Kind' | translate }}</th>
                          <th>{{ 'Name' | translate }}</th>
                          <th>%</th>
                          <th>{{ 'Lines' | translate }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item>
                        <tr>
                          <td>
                            <p-tag
                              [severity]="catalogKindSeverity(item.itemKind)"
                              [value]="item.itemKind"
                            ></p-tag>
                          </td>
                          <td>
                            <a
                              [routerLink]="participationLink(item.itemKind, item.name)"
                              [fragment]="participationFragment(item.itemKind, item.name, item.group)"
                            >{{ item.name }}</a>
                          </td>
                          <td class="runs-cell">{{ item.percent | number: '1.0-1' }}%</td>
                          <td class="runs-cell">{{ item.lines }}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }
              } @else {
                <p class="muted">{{ 'Select an author' | translate }}</p>
              }
            </div>
          </section>
        </div>
      </p-tabpanel>

      <p-tabpanel value="Services" class="catalog-tabpanel">
        <div class="toolbar">
          <input
            pInputText
            type="text"
            [placeholder]="'Filter services, projects, consumers...' | translate"
            [ngModel]="serviceFilter()"
            (ngModelChange)="serviceFilter.set($event)"
          />
        </div>

        <div class="workspace">
          <aside class="group-list">
            <button
              type="button"
              class="group-item"
              *ngFor="let profile of filteredServiceProfiles()"
              [class.active]="activeService() && serviceKey(activeService()!) === serviceKey(profile)"
              (click)="selectService(profile)"
            >
              <span class="group-name" [title]="profile.project">{{ profile.name }}</span>
              <p-tag
                *ngIf="!profile.namingCompliant"
                class="kind-tag"
                severity="danger"
                value="UnitOfWork"
                [pTooltip]="(profile.namingIssues || []).join('\n')"
                tooltipPosition="top"
              ></p-tag>
              <span class="group-count">{{ profile.itemCount }}</span>
            </button>
            <div *ngIf="!filteredServiceProfiles().length" class="empty muted">{{ 'No services match the filter' | translate }}</div>
          </aside>

          <section class="items-panel">
            <div class="panel-title" *ngIf="activeService() as service">
              {{ service.name }}
              <p-tag
                *ngIf="!service.namingCompliant"
                class="kind-tag"
                severity="danger"
                value="UnitOfWork naming"
                [pTooltip]="(service.namingIssues || []).join('\n')"
                tooltipPosition="top"
              ></p-tag>
              <span class="muted">
                · {{ service.project }} · {{ 'mediator' | translate }}: {{ service.commandCount }} · {{ 'jobs' | translate }}: {{ service.jobCount }}
              </span>
              <a
                class="history-link"
                [routerLink]="['/admin/process-management/external-service-calls']"
                [queryParams]="{ serviceName: service.name }"
              >{{ 'View request history' | translate }}</a>
            </div>
            <div class="service-description" *ngIf="activeService() as service">
              <h3>{{ 'Description' | translate }}</h3>
              <p>{{ (service | serverTranslate:'descriptions') || service.description || ('No description available for this service.' | translate) }}</p>
            </div>
            <div class="table-scroll">
              <p-table
                [value]="activeService()?.consumers || []"
                styleClass="p-datatable-sm p-datatable-striped"
                [scrollable]="true"
                scrollHeight="flex"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ 'Kind' | translate }}</th>
                    <th>{{ 'Name' | translate }}</th>
                    <th>{{ 'Group' | translate }}</th>
                    <th>{{ 'Entry point' | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td>
                      <p-tag
                        [severity]="catalogKindSeverity(item.itemKind)"
                        [value]="item.itemKind"
                      ></p-tag>
                    </td>
                    <td>
                      <a [routerLink]="participationLink(item.itemKind, item.name)">{{ item.name }}</a>
                    </td>
                    <td>{{ catalogGroupLabel(item.group) }}</td>
                    <td>
                      <code *ngIf="item.entryPoint">{{ item.entryPoint }}</code>
                      <span *ngIf="!item.entryPoint" class="muted">—</span>
                      <span class="muted" *ngIf="item.kind"> · {{ item.kind }}</span>
                      <p-tag
                        *ngIf="!isExternalServiceNamingCompliant(item)"
                        class="kind-tag"
                        severity="danger"
                        [value]="'naming' | translate"
                        [pTooltip]="externalServiceNamingIssuesTooltip(item) | translate"
                        tooltipPosition="top"
                      ></p-tag>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4" class="muted">{{ 'Select a service' | translate }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </section>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<ng-template #mediatorPanel>
  <div class="toolbar">
    <input
      pInputText
      type="text"
      [placeholder]="'Filter mediator types, kind, cqrs, placement, devops, jobs, chain...' | translate"
      [ngModel]="commandFilter()"
      (ngModelChange)="commandFilter.set($event)"
    />
  </div>

  <div class="workspace" [class.with-details]="!!selectedCommand()">
    <aside class="group-list">
      <button
        type="button"
        class="group-item"
        *ngFor="let group of commandGroups()"
        [class.active]="activeCommandGroup() === group.group"
        [class.archive]="isArchiveGroup(group.group)"
        (click)="selectCommandGroup(group.group)"
      >
        <span class="group-name">{{ catalogGroupLabel(group.group) }}</span>
        <span class="group-count">{{ group.items.length }}</span>
      </button>
      <div *ngIf="!commandGroups().length" class="empty muted">{{ 'No groups match the filter' | translate }}</div>
    </aside>

    <section class="items-panel">
      <div class="panel-title" *ngIf="activeCommandGroup() as groupName">
        {{ catalogGroupLabel(groupName) }}
        <span class="muted">· {{ selectedCommandItems().length }}</span>
      </div>
      <div class="table-scroll">
        <p-table
          [value]="selectedCommandItems()"
          selectionMode="single"
          dataKey="name"
          (onRowSelect)="selectCommand($event.data)"
          styleClass="p-datatable-sm p-datatable-striped catalog-commands-table"
          [scrollable]="true"
          scrollHeight="flex"
          [tableStyle]="{ 'min-width': '72rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pFrozenColumn class="col-name">{{ 'Name' | translate }}</th>
              <th class="col-description">{{ 'Description' | translate }}</th>
              <th class="col-runs">{{ 'Runs' | translate }}</th>
              <th class="col-refs">{{ 'Refs' | translate }}</th>
              <th class="col-jobs">{{ 'Jobs' | translate }}</th>
              <th class="col-chain">{{ 'Chain' | translate }}</th>
              <th pFrozenColumn alignFrozen="right" class="col-returns">{{ 'Returns' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-command>
            <tr
              [pSelectableRow]="command"
              [class.selected-row]="selectedCommand()?.name === command.name"
              (click)="selectCommand(command)"
            >
              <td pFrozenColumn class="col-name">
                <a [routerLink]="commandLink(command.name || '')" (click)="$event.stopPropagation()">
                  {{ command.name }}
                </a>
                <app-catalog-authors [authors]="command.authors"></app-catalog-authors>
                <p-tag
                  class="kind-tag"
                  [severity]="catalogKindSeverity(command.kind)"
                  [value]="command.kind || undefined"
                ></p-tag>
                <p-tag
                  *ngIf="!isCqrsCompliant(command)"
                  class="kind-tag"
                  severity="danger"
                  value="cqrs"
                  [pTooltip]="cqrsIssuesTooltip(command) | translate"
                  tooltipPosition="top"
                ></p-tag>
                <p-tag
                  *ngIf="!isPlacementCompliant(command)"
                  class="kind-tag"
                  severity="danger"
                  value="placement"
                  [pTooltip]="placementIssuesTooltip(command) | translate"
                  tooltipPosition="top"
                ></p-tag>
                <p-tag *ngIf="command.discoveredAtRuntime" severity="warn" value="runtime"></p-tag>
                <p-tag
                  *ngIf="isCatalogItemObsolete(command)"
                  class="kind-tag"
                  severity="secondary"
                  value="obsolete"
                  pTooltip="Retired: marked [Obsolete]"
                  tooltipPosition="top"
                ></p-tag>
                <div
                  class="external-services inline"
                  *ngIf="command.externalServices?.length"
                  [pTooltip]="externalServicesTooltip(command.externalServices)"
                  tooltipPosition="top"
                >
                  <p-tag
                    *ngFor="let service of (command.externalServices || []).slice(0, 2)"
                    class="service-tag"
                    [severity]="isExternalServiceNamingCompliant(service) ? 'secondary' : 'danger'"
                    [value]="service.name || undefined"
                  ></p-tag>
                  <span class="muted" *ngIf="(command.externalServices || []).length > 2">…</span>
                </div>
              </td>
              <td class="description-cell col-description">{{ (command | serverTranslate:'descriptions') || command.description || '—' }}</td>
              <td class="col-runs">
                <a
                  class="runs-cell"
                  [routerLink]="['/admin/process-management/monitoring']"
                  (click)="$event.stopPropagation()"
                  [pTooltip]="formatExecutionTooltip(command.executionCount, command.lastExecutedAt)"
                  tooltipPosition="top"
                >
                  {{ formatExecutionSummary(command.executionCount, command.lastExecutedAt) }}
                </a>
              </td>
              <td class="col-refs">
                <span
                  class="ref-count"
                  [pTooltip]="commandReferencesTooltip(command)"
                  tooltipPosition="top"
                >
                  {{ commandReferenceCount(command) }}
                </span>
              </td>
              <td class="col-jobs">
                <ng-container *ngIf="command.usedByJobs?.length; else noJobs">
                  <a
                    *ngFor="let job of (command.usedByJobs || []).slice(0, 2); let last = last"
                    [routerLink]="jobLink(job)"
                    (click)="$event.stopPropagation()"
                    class="ref-link"
                  >
                    {{ job }}<span *ngIf="!last">, </span>
                  </a>
                  <span *ngIf="(command.usedByJobs || []).length > 2">…</span>
                </ng-container>
                <ng-template #noJobs>—</ng-template>
              </td>
              <td class="col-chain">
                <ng-container *ngIf="command.chainedCommands?.length; else noChain">
                  <a
                    *ngFor="let chained of (command.chainedCommands || []).slice(0, 2); let last = last"
                    [routerLink]="commandLink(chained)"
                    (click)="$event.stopPropagation()"
                    class="ref-link"
                  >
                    {{ chained }}<span *ngIf="!last">, </span>
                  </a>
                  <span *ngIf="(command.chainedCommands || []).length > 2">…</span>
                </ng-container>
                <ng-template #noChain>—</ng-template>
              </td>
              <td pFrozenColumn alignFrozen="right" class="col-returns">{{ command.responseType }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="muted">{{ 'Select a group or adjust the filter' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>

    <aside class="details" *ngIf="selectedCommand() as command">
      <h2>
        <a [routerLink]="commandLink(command.name || '')">{{ command.name }}</a>
        <app-catalog-authors [authors]="command.authors"></app-catalog-authors>
      </h2>
      <p class="muted">
        <p-tag
          [severity]="catalogKindSeverity(command.kind)"
          [value]="command.kind || undefined"
        ></p-tag>
        <p-tag
          *ngIf="!isCqrsCompliant(command)"
          severity="danger"
          value="cqrs"
          [pTooltip]="cqrsIssuesTooltip(command) | translate"
          tooltipPosition="top"
        ></p-tag>
        <p-tag
          *ngIf="!isPlacementCompliant(command)"
          severity="danger"
          value="placement"
          [pTooltip]="placementIssuesTooltip(command) | translate"
          tooltipPosition="top"
        ></p-tag>
        <p-tag
          *ngIf="isCatalogItemObsolete(command)"
          severity="secondary"
          value="obsolete"
          pTooltip="Retired: marked [Obsolete]"
          tooltipPosition="top"
        ></p-tag>
        · {{ catalogGroupLabel(command.group) }} · {{ command.fullName || command.sourcePath }}
      </p>
      <h3>{{ 'Description' | translate }}</h3>
      <p>{{ (command | serverTranslate:'descriptions') || command.description || ('No XML summary found on the command type.' | translate) }}</p>
      <ng-container *ngIf="!isCqrsCompliant(command)">
        <h3>{{ 'CQRS issues' | translate }}</h3>
        <ul>
          <li *ngFor="let issue of command.cqrsIssues || []">{{ issue }}</li>
        </ul>
      </ng-container>
      <ng-container *ngIf="!isPlacementCompliant(command)">
        <h3>{{ 'Placement issues' | translate }}</h3>
        <ul>
          <li *ngFor="let issue of command.placementIssues || []">{{ issue }}</li>
        </ul>
      </ng-container>
      <h3>{{ 'External services' | translate }}</h3>
      <div class="external-services" *ngIf="command.externalServices?.length; else noCommandServices">
        <p-tag
          *ngFor="let service of command.externalServices"
          class="service-tag"
          [severity]="isExternalServiceNamingCompliant(service) ? 'secondary' : 'danger'"
          [value]="service.name || undefined"
          [pTooltip]="
            service.project
              + (service.entryPoint ? ' · ' + service.entryPoint : '')
              + (isExternalServiceNamingCompliant(service)
                ? ''
                : '\n' + externalServiceNamingIssuesTooltip(service))
          "
          tooltipPosition="top"
        ></p-tag>
      </div>
      <ng-template #noCommandServices>
        <p class="muted">{{ 'No external services detected' | translate }}</p>
      </ng-template>
      <h3>{{ 'Executions' | translate }}</h3>
      <p>
        <a
          [routerLink]="['/admin/process-management/monitoring']"
          [pTooltip]="formatExecutionTooltip(command.executionCount, command.lastExecutedAt)"
          tooltipPosition="top"
        >
          {{ formatExecutionSummary(command.executionCount, command.lastExecutedAt) }}
        </a>
        <span class="muted"> · {{ 'from operation monitoring' | translate }}</span>
      </p>
      <h3>{{ 'Parameters' | translate }}</h3>
      <ul class="type-list">
        <li *ngFor="let parameter of command.parameters || []">
          <div>
            <code>{{ parameter.name }}</code>:
            <span class="type-name">{{ parameter.type }}</span>
            <span class="muted" *ngIf="parameter.typeKind && parameter.typeKind !== 'unknown'">
              · {{ parameter.typeKind }}<span *ngIf="parameter.elementType"> of {{ parameter.elementType }}</span>
            </span>
          </div>
          <ul class="type-members" *ngIf="parameter.properties?.length">
            <li *ngFor="let member of parameter.properties">
              <code>{{ member.name }}</code>: {{ member.type }}
            </li>
          </ul>
        </li>
        <li *ngIf="!(command.parameters?.length)" class="muted">{{ 'No parameters' | translate }}</li>
      </ul>
      <h3>{{ 'Returns' | translate }}</h3>
      <p>
        <code>{{ command.responseType }}</code>
        <span class="muted" *ngIf="command.responseTypeShape?.kind">
          · {{ command.responseTypeShape?.kind }}
          <span *ngIf="command.responseTypeShape?.elementType">
            of {{ command.responseTypeShape?.elementType }}
          </span>
        </span>
      </p>
      <ul class="type-members" *ngIf="command.responseTypeShape?.properties?.length">
        <li *ngFor="let member of command.responseTypeShape?.properties || []">
          <code>{{ member.name }}</code>: {{ member.type }}
        </li>
      </ul>
      <h3>{{ 'Referenced by' | translate }} ({{ commandReferenceCount(command) }})</h3>
      <ul>
        <li *ngFor="let source of commandReferenceSources(command)">
          <p-tag [value]="source.kind || undefined"></p-tag>
          <ng-container [ngSwitch]="source.kind">
            <a *ngSwitchCase="'Job'" [routerLink]="jobLink(source.name)"><code>{{ source.name }}</code></a>
            <a *ngSwitchCase="'Command'" [routerLink]="commandLink(source.name)"><code>{{ source.name }}</code></a>
            <span *ngSwitchDefault>{{ source.name }}</span>
          </ng-container>
          <span *ngIf="source.httpMethods?.length"> ({{ source.httpMethods?.join(', ') }})</span>
          <div class="muted" *ngIf="source.path">{{ source.path }}</div>
        </li>
        <li *ngIf="!commandReferenceSources(command).length" class="muted">{{ 'No inbound references' | translate }}</li>
      </ul>
      <h3>{{ 'Used by jobs' | translate }}</h3>
      <ul>
        <li *ngFor="let job of command.usedByJobs || []">
          <a [routerLink]="jobLink(job)"><code>{{ job }}</code></a>
        </li>
        <li *ngIf="!(command.usedByJobs?.length)" class="muted">{{ 'Not referenced by Quartz jobs' | translate }}</li>
      </ul>
      <h3>{{ 'Command chain' | translate }}</h3>
      <ul>
        <li *ngFor="let chained of command.chainedCommands || []">
          <a [routerLink]="commandLink(chained)"><code>{{ chained }}</code></a>
        </li>
        <li *ngIf="!(command.chainedCommands?.length)" class="muted">{{ 'No nested MediatR sends detected' | translate }}</li>
      </ul>
      <h3>{{ 'Callers' | translate }}</h3>
      <ul>
        <li *ngFor="let caller of command.callers || []">
          <p-tag [value]="caller.kind || undefined"></p-tag>
          <ng-container *ngIf="caller.kind === 'Job'; else plainCaller">
            <a [routerLink]="jobLink(caller.name || '')"><code>{{ caller.name }}</code></a>
          </ng-container>
          <ng-template #plainCaller>{{ caller.name }}</ng-template>
          <span *ngIf="caller.httpMethods?.length"> ({{ caller.httpMethods?.join(', ') }})</span>
          <div class="muted">{{ caller.path }}</div>
        </li>
        <li *ngIf="!(command.callers?.length)" class="muted">
          {{ 'No API/job callers indexed yet. Regenerate the catalog if this is unexpected.' | translate }}
        </li>
      </ul>
    </aside>
  </div>
</ng-template>
